// for unassigment of employee
export const RESET_GET_EMPLOYEE_PAYROLL_BY_ID = "resign_get_employees_payroll_by_ids";
export const GET_EMPLOYEE_PAYROLL_BY_ID = "get_employees_payroll_by_ids";
export const GET_EMPLOYEE_PAYROLL_BY_ID_SUCCESS = "get_employees_payroll_by_ids_success";
export const GET_EMPLOYEE_PAYROLL_BY_ID_FAILURE = "get_employees_payroll_by_ids_failure";
